import React from 'react';
import { useTranslation } from 'react-i18next';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { App, ModalFuncProps } from 'antd';

interface CustomConfirmConfig extends ModalFuncProps {
  confirmLoading?: boolean;
}
function useCustomConfirmModal() {
  const { modal } = App.useApp();
  const { t } = useTranslation();

  const defaultIcon = <ExclamationCircleOutlined />;

  function confirm(config: CustomConfirmConfig) {
    const fixConfig = {
      wrapClassName: 'CustomConfirmModal',
      closable: true,
      centered: true,
    };
    return modal.confirm({
      ...config,
      icon: config.icon || defaultIcon,
      width: config.width || 416,
      okText: t('Common.Determine'),
      okButtonProps: {
        type: 'default',
        loading: config.confirmLoading || false,
      },
      cancelButtonProps: {
        type: 'primary',
      },
      ...fixConfig,
    });
  }
  return [confirm] as [typeof confirm];
}

export default useCustomConfirmModal;
